module.exports = __webpack_public_path__ + "243b0355484e82c88d156b9b3bea1e24.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-9.png
// module id = 2480
// module chunks = 0